
import * as React from 'react'
import {CSSProperties} from 'react';
import * as Tgcc from '../tgccGlobal';
import * as Request from '../tgccRequest';
import {Message} from '../Components/Message';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {RealCampusHdr} from './RealCampusHdr';
import { RealCampusFooter } from './RealCampusFooter';
import { RealCampusFeedback } from './RealCampusFeedback';


const btn : CSSProperties = {
    border: "1px solid transparent",
    backgroundColor: '#5E6A74',
    height: '40px',
    lineHeight: '40px',
    fontSize: '15px',
    padding: '0px 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '25px auto',
    width: '200px',
    fontFamily: 'Reitam'
}

const hdr: CSSProperties = {
    textAlign: 'center',
    fontFamily: 'BarlowMedium',
    color:'#5E6A74',
    fontSize:'20px',
    marginBottom:'15px'
}
const style: CSSProperties = {
    border:'1px solid rgb(166, 166, 166)',
    fontFamily: 'BarlowMedium',
    color: 'black',
    fontStyle:'italic',
    width:'350px',
    marginBottom:'15px'
}
const errStyle: CSSProperties = {
    color:'red',
    textAlign:'center',
    fontSize:'15px'
}
const formDiv: React.CSSProperties = {
    width:'50%',
    padding:'20px',
    color:'rgb(180, 181, 180)',
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
}
const btnDiv: React.CSSProperties = {
    display:'flex',
    alignItems:'center'
}
const leadDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
}
const leadCont: React.CSSProperties = {
    display:'flex',
    justifyContent:'center'
}
const leftpanel: React.CSSProperties = {
    backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Social_2.png') + ')',
    width:'50%',
    backgroundRepeat:'no-repeat',
    backgroundSize:'cover',
    height:'600px'
}
const requestHdr: React.CSSProperties = {
    fontSize:'36px',
    fontFamily:'Lulo',
    display:'flex',
    alignSelf:'center',
    marginBottom:'30px',
    color:'#5E6A74'
}
class LeadProps extends Tgcc.BaseProps{
    lead:boolean ;
}

class _RealCampusSchoolRequest extends React.Component<LeadProps,any> {
    state = {
        name:null,
        email:null,
        school:null,
        finished:false,
        error:'',
        isWaiting: false,
        org:null
    }
    componentDidMount(){
        var tag = document.getElementById('schoolRequest');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    handleNameChange = (evt: React.FormEvent<HTMLInputElement>) =>{
        this.setState({name:evt.currentTarget.value});
    }
    handleEmailChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({email:evt.currentTarget.value});
    }
    handleSchoolChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({school:evt.currentTarget.value});
    }
    handleOrgChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({org:evt.currentTarget.value});
    }
    sendSchoolRequest = () => {       
        if(!this.state.name){
            this.setState({error:"Please provide your name."})
        } else if(!this.state.email){
            this.setState({error:"Please provide your email address."})
        }
        else {
            this.setState({isWaiting:true});
            var schoolRequest = new Tgcc.SchoolRequest
            schoolRequest.name = this.state.name;
            schoolRequest.email = this.state.email;
            schoolRequest.school = this.state.school;
            schoolRequest.org = this.state.org;
            schoolRequest.timestamp = new Date().toLocaleString();
            Request.sendSchoolRequest(schoolRequest,this.finished)
            this.props.dispatch({type: Tgcc.StateAction.SchoolRequest, payload: true});
        }
    }
    finished = () => {
        this.setState({finished:true});
    }
    whenFinished = () => {
        browserHistory.push(Tgcc.Routes.RealCampusHome);
    }
    getThankYou = () => {
        return <Message 
            Title="Thanks for the request!"         
            UseTitleScript={true}
            Message1="Have a great day!"
            onContinue={this.cancel}
            btnStyle="5E6A74"
        />

    }
    cancel = () => {
        this.setState({finished:false});
        this.setState({isWaiting:false});
        this.props.dispatch({type: Tgcc.StateAction.SchoolRequest, payload: true});
        window.location.reload()
    }
    getLeadForm(){
            var waiting = this.state.isWaiting ? Tgcc.workingGif: <div style={btnDiv} onClick={this.sendSchoolRequest}><div style={btn} className="leadShipBtn">Submit School</div></div>
               return (

                <div style={formDiv} className="schoolForm">
                <div style={requestHdr} className="requestSchool">Request Your School</div>

                <div style={hdr}>Simply fill out the form below with your contact and school information. We will begin working on adding your school as soon as possible.</div>
                <div style={errStyle}>{this.state.error}</div>
                <div style={leadDiv}>
                    <input style={style} className="leadFormInp" type="text" name="name" placeholder="Name" onChange={this.handleNameChange}/>
                    <input style={style} className="leadFormInp" type="text" name="email" placeholder="Email" onChange={this.handleEmailChange}/>
                    <input style={style} className="leadFormInp" type="text" name="school" placeholder="School" onChange={this.handleSchoolChange}/>
                    <input style={style} className="leadFormInp" type="text" name="org" placeholder="Organization" onChange={this.handleOrgChange}/>
                    {waiting}
                </div>
                  </div>
            )
    }

    render () {
        var thankYou = this.state.finished ? this.getThankYou() : null;

        return (
            <div>
                <div id='schoolRequest'></div>
                <RealCampusHdr />
                <div style={leadCont} className="schoolDiv">
                    <div style={leftpanel} className="schoolImg"></div>
                    {this.getLeadForm()}
                    {thankYou}
                </div>
                <RealCampusFooter state={this.props.state} />
                <RealCampusFeedback state={this.props.state} />
            </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState,lead:any) => {
    return { 
        lead: state.didLead,
    };
    
};
export var RealCampusSchoolRequest = connect(mapStateToProps)(_RealCampusSchoolRequest);